import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AnnouncementsHistoryListItem } from "../../content.types";
import { requestAnnouncementsHistory } from "./announcementsHistory.request";

const useAnnouncementsHistory = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<AnnouncementsHistoryListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["announcements", requestParams],
    queryFn: async () => await requestAnnouncementsHistory(requestParams),
    ...options
  });

  return { announcementsHistory: data?.data, meta: data?.meta, ...rest };
};

export default useAnnouncementsHistory;
